import { CompanyEntry } from "../../types";
import {
  CompanyCreate,
  Company as CompanyFromApi,
  CompanyUpdate,
} from "../../api";

export const companiesCreateToExternal = (
  entry: CompanyEntry,
): CompanyCreate => ({
  name: entry.name,
  registry_code: entry.registryCode,
  legal_address: entry.legalAddress,
  is_supplier: entry.isSupplier,
  is_transporter: entry.isTransporter,
  is_buyer: entry.isBuyer,
});

export const companiesUpdateToExternal = (
  entry: Partial<CompanyEntry>,
): CompanyUpdate => ({
  name: entry.name,
  registry_code: entry.registryCode,
  is_supplier: entry.isSupplier,
  is_transporter: entry.isTransporter,
  is_buyer: entry.isBuyer,
});

export const companiesFromExternalList = (
  entry: CompanyFromApi,
): CompanyEntry => ({
  id: entry.id,
  registryCode: entry.registry_code,
  legalAddress: entry.legal_address,
  name: entry.name,
  isSupplier: entry.is_supplier,
  isTransporter: entry.is_transporter,
  isBuyer: entry.is_buyer,
  commentsCount: entry.comments_count,
});
